// src/components/Ielts_test/welcome/HeroSection.jsx
import React from 'react';
import {Talent11} from "../../../assets"; 

const HeroSection = () => {
  const scrollToCategory = () => {
    const categorySection = document.getElementById('category-section');
    if (categorySection) {
      const yOffset = -80;
      const y = categorySection.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <section className="from-custom-bg to-white py-8 px-4 md:py-16 md:px-8 relative overflow-visible">
      <div className="max-w-6xl mx-auto">
        {/* Card Utama */}
        <div className="bg-gradient-to-r from-primary to-blue-500 rounded-3xl p-6 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10 text-white relative z-10 shadow-xl">
          {/* Text Content */}
          <div className="flex-1 text-center md:text-left">
            <h1 className="text-2xl md:text-4xl font-bold font-poppins mb-3">
              IELTS Simulation Test
            </h1>
            <p className="text-sm md:text-base font-roboto mb-6 leading-relaxed">
              Latih kemampuanmu dengan simulasi tes IELTS sesuai kategori pilihanmu. <br className="hidden md:block" />
              Tes ini dirancang untuk membantu mempersiapkan ujian IELTS dengan format dan tingkat kesulitan yang serupa.
            </p>
            <button
              onClick={scrollToCategory}
              className="bg-accent text-white font-poppins font-semibold px-6 py-3 rounded-full hover:bg-yellow-500 transition shadow-md"
            >
              Pilih Kategori Tes
            </button>
          </div>
          {/* Placeholder agar layout tetap saat gambar di-hook */}
          <div className="hidden md:block w-48 h-48 md:w-64 md:h-64 flex-shrink-0" />
        {/* Gambar "Hook" ke Bawah Card */}
        <div className="absolute right-4 md:right-8 -bottom-3 hidden md:block z-0 pointer-events-none">
          <img
            src={Talent11}
            alt="IELTS Instructor"
            className="w-48 h-48 md:w-64 md:h-64 object-contain drop-shadow-2xl"
          />
        </div>
      </div>
       </div>
    </section>
  );
};

export default HeroSection;